export function required(val) {
  return !!val || 'This field is required';
}

export function toDollar(val) {
  const charArray = Array.from(val.toString());
  const cents = charArray.splice(charArray.length - 2, 2).join('');
  let dollars;
  if (!charArray.length) {
    dollars = '0';
  } else {
    for (let i = charArray.length - 1, j = 0; i > 0; i -= 1) {
      j += 1;
      if (j === 3) {
        charArray.splice(i, 0, ',');
        j = 0;
      }
    }
    dollars = charArray.join('');
  }
  return `$${dollars}.${cents}`;
}
